import { render, staticRenderFns } from "./VoucherCardMinimalist.vue?vue&type=template&id=f21ea154&scoped=true&"
import script from "./VoucherCardMinimalist.vue?vue&type=script&lang=js&"
export * from "./VoucherCardMinimalist.vue?vue&type=script&lang=js&"
import style0 from "./VoucherCardMinimalist.vue?vue&type=style&index=0&id=f21ea154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21ea154",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VChip,VCol,VRow,VSpacer})
